import type {
	LineageFlowMonitor,
	LineageFlowNodeData,
	LineageFlowTest,
} from '@repo/api-codegen';
import type { IconNames } from '@repo/foundations';
import type { Node } from '@xyflow/react';

export enum LineageFlowNodeVisibilityState {
	VISIBLE = 'VISIBLE',
	SKELETON = 'SKELETON',
	HIDDEN = 'HIDDEN',
	LOADING = 'LOADING',
}

export interface LineageFlowEntityNodeData extends LineageFlowNodeData {
	tests?: LineageFlowTest[];
	monitors?: LineageFlowMonitor[];
	[key: string]: unknown;
}

export interface LineageFlowNode extends Node<LineageFlowEntityNodeData> {}

export function isLineageFlowNode(node: unknown): node is LineageFlowNode {
	if (!node || typeof node !== 'object') {
		return false;
	}

	const candidate = node as LineageFlowNode;
	return candidate.type === 'ENTITY';
}

export type LineageFlowBounds = {
	left: number;
	right: number;
	top: number;
	bottom: number;
};

export type LineageFlowNodeAction = {
	label: string;
	icon: IconNames;
	onClick: (...args: any[]) => void;
};

export type LineageFlowNodeActions = {
	analyzeImpact: LineageFlowNodeAction;
	nodeClick: LineageFlowNodeAction;
};
